<template>
  <div>
        <v-form ref="formDatosGenerales" lazy-validation>
      <v-sheet color="grey lighten-2" height="200px" class=""
        v-if="readyloadProg && parametros.items.id_sesion_aprendizaje != null">
        <v-skeleton-loader class="mx-auto" width="auto" type="card-avatar"></v-skeleton-loader>
      </v-sheet>
      <v-row v-else-if="listCompetencias.length != 0">
        <v-col cols="12" lg="3">
          <v-text-field :value="`Sesión ${datosSA.correlativo_sa} / ${totalTemasSA}`" readonly></v-text-field>
        </v-col>
        <v-col cols="12" lg="3">
          <v-text-field label="Docente" v-model="docente.nombre" readonly></v-text-field>
        </v-col>
        <v-col cols="12" lg="3">
          <v-text-field label="Tutor" v-model="tutor.nombre" readonly></v-text-field>
        </v-col>
        <v-col cols="12" lg="3">
          <v-text-field v-model="datosProgDocente.fecha_aplicacion" label="Fecha de aplicación" ref="fecha_aplicacion"
            type="date" :disabled="parametros.evento == 'view'"
            :rules="validationRules.validateCampo"></v-text-field>
        </v-col>

        <v-col cols="12" lg="2">
          <v-text-field label="Tiempo de ejecución" v-model="datosSA.tiempo_aplicacion" :disabled="true"
            :rules="validationRules.validateCampo"></v-text-field>
        </v-col>
        <v-col cols="12" lg="5">
          <v-textarea label="Enfoques transversales" v-model="datosSA.enfoques_transversales" :disabled="true"
            rows="1" :rules="validationRules.validateCampo"></v-textarea>
        </v-col>
        <v-col cols="12" lg="5">
          <v-textarea label="Objetivos" v-model="datosSA.objetivos" :disabled="true" rows="1"
            :rules="validationRules.validateCampo"></v-textarea>
        </v-col>
      </v-row>

      <v-row v-if="parametros.items.id_sesion_aprendizaje == null">
        <v-col cols="12">
          <v-alert color="error" icon="$warning">
            No existen sesiones asociadas a este tema!
          </v-alert>
        </v-col>
      </v-row>

      <v-row v-if="!readyloadProg">
        <v-col cols="12">
          <v-card outlined>
            <v-card-title class="d-flex justify-center text-subtitle-2">
              Leyenda
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" class="d-flex justify-center">
                  <div class="leyenda-comptencia mx-2">
                  </div>
                  Competencia
                  <div class="leyenda-capacidad mx-2">
                  </div>
                  Capacidades
                  <div class="leyenda-desempeno mx-2">
                  </div>
                  Desempeños
                </v-col>
              </v-row>
            </v-card-text>

          </v-card>
        </v-col>
        <!-- v-if="checkedCompentencias == item02.id"   -->
        <v-col cols="12" v-for="(item01, index01) in listCompetencias" :key="index01" class="py-0">
          <v-row v-for="(item02, index02) in item01.competencias" :key="index02">
            <v-col cols="12" v-if="checkedCompentencias.includes(item02.id)">
              <v-card outlined>
                <v-card-title class="d-flex text-subtitle-2">
                  Competencias
                </v-card-title>
                <v-card-text>
                  <v-row class="competencia white--text">
                    <v-col cols="1" md="1" class="pr-0 d-flex justify-center">
                      <v-checkbox dark :value="item02.id" v-model="checkedCompentencias" :disabled="true"
                        @change="EventCompetencia($event, index01, item02.id, index02)" class="">{{checkedCompentencias}}
                      </v-checkbox>
                    </v-col>
                    <v-col cols="11" md="11" class="pl-0 d-flex justify-start align-center">
                      <div style="text-align: justify">
                        <i class="fas fa-chevron-right fa-lg ico_competencia"></i>
                        {{ item02.descripcion }}
                      </div>
                    </v-col>
                    <v-col cols="12" class="pt-0" v-if="item02.capacidades">
                      <v-card outlined>
                        <v-card-title class="text-subtitle-2 pl-0">
                          <v-col cols="11" offset="1" class="py-0">
                            Capacidades
                          </v-col>
                        </v-card-title>
                        <v-card-text>
                          <v-row class="capacidades white--text">
                            <v-col cols="12" v-if="item02.capacidades">
                              <v-row v-for="(item03, index03) in item02.capacidades" :key="index03">

                               <template v-if="checkedCapacidades.includes(item03.id)"> 
                                  <v-col cols="1" md="1" offset="1" class="px-0 d-flex justify-center">
                                    <v-checkbox class="" :value="item03.id" v-model="checkedCapacidades"
                                      :disabled="true" @change="
                                        EventCapacidad(
                                          $event,
                                          index01,
                                          item03.id,
                                          index02,
                                          index03
                                        )
                                        ">
                                    </v-checkbox>
                                  </v-col>
                                  <!-- mx-2 -->
                                  <v-col cols="10" md="10" class="pl-0 d-flex align-center justify-start">
                                    <div style="text-align: justify">
                                      <i class="fas fa-caret-right fa-lg ico_capacidad"></i>
                                      {{ item03.descripcion }}
                                    </div>
                                  </v-col>
                              </template>

                                <v-col cols="12" class="pt-0" v-if="item03.indicador">
                                  <v-card>
                                    <v-card-title v-if="index03 === 0" class="d-flex text-subtitle-2 pl-0">
                                      <v-col cols="10" offset="2" class="py-0">
                                          Desempeños
                                      </v-col>
                                      
                                    </v-card-title>
                                    <v-card-text>
                                      <v-row class="desempeno" v-for="(item04, index04) in item03.indicador"
                                        :key="index04">
                                        <template v-if="checkedIndicadores.includes(item04.id)"> 
                                        <v-col cols="1" md="1" offset="2" class="px-0 d-flex justify-center">
                                          <v-checkbox :value="item04.id" v-model="checkedIndicadores"
                                            :disabled="true"
                                            @change="EventIndicador($event, item02, item03, item04)" class="">
                                          </v-checkbox>
                                        </v-col>
                                        <v-col cols="11" md="9" class="pl-0 align-center d-flex justify-start">
                                          <div style="text-align: justify">
                                            <i class="fas fa-angle-double-right fa-lg ico_indicador"></i>
                                            {{ item04.descripcion }}
                                          </div>
                                        </v-col>
                                      </template>
                                      </v-row>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                                <!--
                                    /////////////////////////////////
                                        DESEMPEÑO O INIDICADORES
                                    /////////////////////////////////
                                -->
                                <!-- Imten03 DETALLE DE INDICADORES O DESEMPEÑO -->
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <!-- FIN DE CAPACIDADES -->
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <br />
        </v-form>   
  </div>
</template>

<script>
import axios from "@/helpers/axios";
// eslint-disable-next-line no-unused-vars
import { mapMutations, mapGetters, mapActions } from "vuex";
import { validationRules } from '../../../../../helpers/validatorHelpers';

export default {
  name: "FormSesionAprendizaje",
  components: {},

  props: {
    parametros: {
      type: Object,
    },
    estadoComp: {
      type: Boolean,
    },
    idseccion: {
      type: Number,
    },
    // idProgDocente: {
    //   type: Number,
    // },
    fecha: {
      type: String,
    },
  },
  data: () => ({
    esperanza: false,
    datoLogin: sessionStorage,
    readyloadProg: true,
    test: false,
    guardandoDatosGenerales: false,
    datosSA: {},
    datosTema: {},
    totalTemasSA: "",
    id_curriculo: -1,
    listCompetencias: [],
    listIndicadores: [],
    checkedCompentencias: [],
    checkedCapacidades: [],
    checkedIndicadores: [],
    datosProgDocente: {
      id: null,
      id_colegio: sessionStorage.id_colegio,
      id_persona: sessionStorage.id_persona,
      fecha_aplicacion: "",
    },
    tutor: {
      nombre_persona: "",
      ape1_persona: "",
      ape2_persona: "",
    },
    docente: {
      nombre_persona: "",
      ape1_persona: "",
      ape2_persona: "",
    },
  }),

  watch: {
    estadoComp() {
      if (this.estadoComp) {
        this.loadMain();
      } else {
        // this.readyloadProg = true;
      }
    },

    idseccion(value) {

      console.log('value props', value);

      if (value) {
        this.cargarTutor(value);
      }
    },

    fecha(value) {

      if (value) {
        this.datosProgDocente.fecha_aplicacion = value;

        this.setSesionAprendizaje({
            ...this.datosSA, 
            id_colegio: this.parametros.id_colegio,
            id_ano_lectivo: parseInt(this.datoLogin.id_ano_lectivo),
            id_nivel: this.parametros.id_nivel,
            id_grado: this.parametros.id_grado,
            id_area: this.parametros.id_area,
            fecha_aplicacion: value,
            id_us_ing: parseInt(this.datoLogin.id),
            id_docente:this.datosProgDocente.id_docente
        });
      }
      // if (this.parametros.evento != "editar" && (value != null || value != "")) {
      // }
    },
  },

  computed: {
    ...mapGetters("login", ["componenteEvento"]),
    validationRules() {
      return validationRules
    }
  },
  created() {
    // this.actualizarParamentro();
  },
  mounted() {
    this.loadMain()
    // this.initGA();
  },
  methods: {
    ...mapMutations({
          setEnviarMens: "mensajeSis/setEnviarMens",
          setSesionAprendizaje: "progDocente/setDataSesionAprendizaje"
      }),
    async loadMain() {
      this.readyloadProg = true;

      this.datosTema = this.parametros.items; 

      console.log('datosTema',  this.datosTema);
      //CREACIONES
      if (this.parametros.items.id_sesion_aprendizaje != null) {
        
        await this.GetCurriculo();
        await this.GetAllCompetencias();

        switch (this.parametros.evento) {
          case "agregar":
            this.datosSA.tiempo_aplicacion = "90 minutos";
            await this.AddItem();
          break;
        
          case "editar":
          this.datosSA.tiempo_aplicacion = "90 minutos";
            await this.EditItem();
          break;

          case "ver": 
            this.datosProgDocente.fecha_aplicacion = this.parametros.items.fecha;  
            await this.AddItem();
          break;

          default:
          break;
        }
        
      }
    },

    cargarTutor(idseccion) {
      this.datosTema.id_seccion = idseccion;
      this.GetTutor();
    },

    async AddItem() {
      try {
        if (this.parametros.tipo_contenido == 1) {

          let response = await axios.get(
            `/manager/sesionAprendizaje/clase/${this.parametros.items.id_clase}/`
          );
          if (response != null) {

            console.log('response.data', response.data);

            this.datosSA = response.data;
            this.datosSA.tipo_contenido = 1;
            this.datosSA.id_colegio = parseInt(this.datoLogin.id_colegio);
            this.datosSA.id_docente = null;
            // this.datosProgDocente.fecha_aplicacion = null;
            this.MostrarIndicadoresSeleccionados();
            this.GetPersona(this.datoLogin.id_persona);
            
          } else {
            return;
          }
        }

        if (this.parametros.tipo_contenido == 0) {
          let resp = await axios.get(
            `/academico/sesionAprendizaje/clase/${this.parametros.items.id_clase}/`
          );
          this.datosSA = resp.data;
          // this.datosSA.id_prog_docente = item.id;
          this.datosSA.tipo_contenido = 0;
          this.datosSA.id_colegio = parseInt(this.datoLogin.id_colegio);
          this.datosSA.id_docente = null;
          // this.datosProgDocente.fecha_aplicacion = item.fecha;
          // this.datosSA.correlativo_sa = "";
          this.MostrarIndicadoresSeleccionados();
          this.GetPersona(this.datoLogin.id_persona);
        }

        this.GetCorrelativoSA(this.parametros.tipo_contenido)

      } catch (error) {
        console.log(error);
        
      } 
    },

    async EditItem() {

      try {

        let resp;

        if (this.parametros.tipo_contenido == 1) {
          resp = await axios.get(
            `/manager/sesionAprendizaje/clase/${this.parametros.items.id_clase}/`
          );

        } else {
          resp = await axios.get(
            `/academico/sesionAprendizajeProg/clase/${this.parametros.items.id_clase}/`
          );
        }

        if (resp.data) {
          this.datosSA = resp.data;

          this.MostrarIndicadoresSeleccionados();
          this.GetCorrelativoSA(this.parametros.tipo_contenido);

          this.datosProgDocente.fecha_aplicacion = this.datosTema.fecha;
          this.GetDocente(this.datosTema.id_profesor);

          // if (this.parametros.evento == "view") {
          //   this.$emit(
          //     "reloadComp",
          //     this.datosSA.id,
          //     this.parametros.evento,
          //     1
          //   );
          // }

          // if (this.parametros.evento == "editar") {
          //   this.datosProgDocente.fecha_aplicacion = this.datosTema.fecha;
          //   this.GetDocente(this.datosTema.id_profesor);
          //   this.$emit(
          //     "reloadComp",
          //     this.datosSA.id,
          //     this.parametros.evento,
          //     1
          //   );
          // }

          // if (this.parametros.evento == "replicar") {
          //   this.$emit(
          //     "reloadComp",
          //     this.datosSA.id,
          //     this.parametros.evento,
          //     1
          //   );
          // }
        }
        this.GetTutor();
      } catch (error) {
        console.log(error);
      }
    },

    async GetCurriculo() {
      try {
        let resp = await axios.get(
          `/administrativo/curriculo/list/cr/colegio/${this.datoLogin.id_colegio}/anoLectivo/${this.datoLogin.id_ano_lectivo}`
        );
        let valorFiltro = resp.data;
        let result = valorFiltro.find((element) => (element.status = 1));
        if (result) {
          this.id_curriculo = result.id;
        } else {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `No existe un curriculo asociado activo al año lectivo `,
            tiempo: 6000,
          });
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async GetAllCompetencias() {

      this.listCompetencias = [];

      const params = {
        id_colegio: this.datoLogin.id_colegio,
        id_curriculo: this.id_curriculo,
        id_ano_lectivo: this.datoLogin.id_ano_lectivo,
        id_nivel: this.parametros.id_nivel,
        id_grado: this.parametros.id_grado,
        id_area: this.parametros.id_area,
      };

      try {
        let resp = await axios.post(
          `/administrativo/competencia/cs/all/`,
          params
        );
        this.listCompetencias = resp.data;

      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      } finally {
        setTimeout(async () => {
          this.readyloadProg = false;
        }, 300);
      }
    },

    async EventCompetencia(
      event,
      indexPrincipal,
      id_competencia_area,
      indexComp,
      recargar = false
    ) {
      // event: si esta chequeado o NO la competencia (true, false)
      // indexPrincipal:  posicion del elemento del index Principal
      // id_competencia_area:  campo unico de la tabla competencia
      // indexComp: posicion del elemento de la compentencia

      if (recargar) {
        this.listCompetencias[indexPrincipal].competencias[
          indexComp
        ].capacidades = [];
      }

      if (event) {
        try {
          var resp = await axios.get(
            `/manager/capacidad/gall/${id_competencia_area}`
          );
      
          // let resp = await axios.get(`/administrativo/capacidad/listAllCapacidad/${id_competencia_area}`)

          if (resp.data.length == 0) {
            this.listCompetencias[indexPrincipal].competencias[
              indexComp
            ].capacidades = [];
          } else {
            this.listCompetencias[indexPrincipal].competencias[
              indexComp
            ].capacidades = resp.data;
          }
          
        } catch (error) { 
          if(error.message == 'Cannot set properties of undefined (setting \'capacidades\')'){
            this.setEnviarMens({
              tipo: 'E',
              mensaje:'Hubo un error al cargar los datos, solicite al proveedor del servicio que vuelva a configurar las Capacidades.',
              tiempo: 5000,
            });

          await axios.delete("/manager/sesionAprendizaje/indicadores/" +  this.parametros.items.id_sesion_aprendizaje)
      
          this.$emit('listener', 'returnBack', null);

          }else{
             this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
          }
        }
        //check es false
      } else {
        this.listCompetencias[indexPrincipal].competencias[
          indexComp
        ].capacidades = null;
      }
    },
    
    async EventCapacidad(
      event,
      indexPrincipal,
      id_capacidad,
      indexComp,
      indexCap
    ) {
      if (event) {
        try {
          // Listar los Indicadores o Desempeños
          var resp = await axios.get(`/manager/indicador/gall/${id_capacidad}`);
          /*
                    let params = {
                        // id_curriculo: this.filtro.id_curriculo,
                        id_competencia_area:null,
                        id_mgr_capacidad:null,
                        id_capacidad
                    }
                    var resp   = await axios.post(`/administrativo/indicador/listInd/`,params)
                    */
          if (resp.data.length == 0) {
            this.com[indexPrincipal].competencias[indexComp].capacidades[
              indexCap
            ].indicador = [];
          } else {
            this.listCompetencias[indexPrincipal].competencias[
              indexComp
            ].capacidades[indexCap].indicador = resp.data;
          }
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
          this.listCompetencias[indexPrincipal].competencias[
            indexComp
          ].capacidades[indexCap].indicador = [];
        }

        // Limpia los Indicadores Seleccionado
      } else {
        this.listCompetencias[indexPrincipal].competencias[
          indexComp
        ].capacidades[indexCap].indicador = null;
      }
    },

    async EventIndicador(event, competencia, capacidades, indicador) {
      // this.setEnviarMens({tipo:"W", mensaje: `HOLA Desempeño EDITAR`, tiempo:null})

      // SELECCIONADO
      if (event.length > 0 && event.find((i) => i == indicador.id)) {
        // FALTA DEFINIR EL ORIGEN
        let items = {
          id_competencia: competencia.id,
          id_capacidad: capacidades.id,
          id_indicador: indicador.id,
          origin: indicador.origen,
        };
        this.listIndicadores.push(items);
      } else {
        let index = this.listIndicadores.findIndex(
          (item) => item.id_indicador === indicador.id
        );
        this.listIndicadores.splice(index, 1);
      }
    },    

    async MostrarIndicadoresSeleccionados() {

      let competencias = [];
      let capacidades = [];
      this.listIndicadores = this.datosSA.indicadores;


      console.log('SesionAprendizaje', this.datosSA.indicadores);
      console.log('formSesionAprendizaje', this.listIndicadores);

      this.checkedIndicadores = this.listIndicadores.map((i) => i.id_indicador);

      console.log('this.checkedIndicadores', this.checkedIndicadores);

      for (let i = 0; i < this.listIndicadores.length; i++) {
        const indicador = this.listIndicadores[i];
        if (
          !competencias.find((element) => element == indicador.id_competencia)
        ) {
          competencias.push(indicador.id_competencia);
          let indexComp = this.listCompetencias[0].competencias.findIndex(
            (competencia) => competencia.id == indicador.id_competencia
          );
          await this.EventCompetencia(
            true,
            0,
            indicador.id_competencia,
            indexComp
          );
        }
        capacidades.push(indicador.id_capacidad);
      }

      this.listCompetencias[0].competencias.forEach((objeto, indiceObjeto) => {
        if (objeto.capacidades != null) {
          objeto.capacidades.forEach((capacidad, indiceCapacidad) => {
            if (capacidades.includes(capacidad.id)) {
              this.EventCapacidad(
                true,
                0,
                capacidad.id,
                indiceObjeto,
                indiceCapacidad
              );
            }
          });
        }
      });

      this.checkedCompentencias = competencias;
      this.checkedCapacidades = capacidades;
    },

    LimpiarForm() {
      this.datosSA = {
        id_usuario: sessionStorage.id,
        id: -1,
        id_nivel: -1,
        id_grado: -1,
        id_area: -1,
        id_tema: -1,
        id_clase: -1,
        id_docente: -1,
        id_tutor: -1,
        id_prog_docente: -1,
        id_ano_lectivo: -1,
        correlativo_sa: -1,
        tiempo_aplicacion: "",
        enfoques_transversales: "",
        objetivos: "",
        id_us_ing: null,
        id_us_mod: null,
        fec_us_ing: "",
        fec_us_mod: "",
        tipo_contenido: -1,
        indicadores: [],
      };

      this.listCompetencias = [];
      this.$refs.formDatosGenerales.resetValidation();
    },

    async GetTutor() {
      try {
        let resp = await axios.get(
          `/academico/sesionAprendizajeProg/getTutor/${parseInt(this.datoLogin.id_colegio)}/${parseInt(this.datoLogin.id_ano_lectivo)}/${parseInt(this.datosTema.id_seccion)}/${parseInt(this.datosTema.id_curso)}/`
        );

        console.log('resp', resp);

        this.datosSA.id_tutor = -1;
        if (resp.data) {
          this.tutor = resp.data;
          this.tutor.nombre = `${this.tutor.nombre_persona} ${this.tutor.ape1_persona} ${this.tutor.ape2_persona}`;
          // this.datosProgDocente.id_tutor = this.tutor.id_personal;
          this.datosSA.id_tutor = this.tutor.id_personal;
        }
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error al consultar datos de la programación del docente para la sesión de aprendizaje`,
          tiempo: null,
        });
      }
    },

    async GetPersona(id_persona) {
      // this.datosProgDocente.fecha_aplicacion = this.parametros.item.fecha;
      try {
        var resp = await axios.get(
          `/academico/sesionAprendizajeProg/getPersonaDocente/${this.datoLogin.id_colegio}/${id_persona}/`
        );

        if (resp.data) {
          this.docente = resp.data;
          this.docente.nombre = `${this.docente.nombre_persona} ${this.docente.ape1_persona} ${this.docente.ape2_persona}`;
          this.datosProgDocente.id_docente = this.docente.id_personal;
        }
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error al consultar datos de la programación del docente para la sesión de aprendizaje`,
          tiempo: null,
        });
      }
    },

    async GetDocente(id_docente) {
      try {
        var resp = await axios.get(
          `/academico/sesionAprendizajeProg/getDocente/${this.datoLogin.id_colegio}/${id_docente}/`
        );
        if (resp.data) {
          this.docente = resp.data;
          this.docente.nombre = `${this.docente.nombre_persona} ${this.docente.ape1_persona} ${this.docente.ape2_persona}`;
          this.datosProgDocente.id_docente = id_docente;
        }
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error al consultar datos de la programación del docente para la sesión de aprendizaje`,
          tiempo: null,
        });
      }
    },

    async GetCorrelativoSA(tipo_contenido) {
      try {
        var resp = await axios.get(
          // `/academico/sesionAprendizajeProg/countSA/${this.datosSA.id_colegio}/${this.datosSA.id_tema}/${null}/`
          `/academico/sesionAprendizajeProg/countSA_Tema/${this.datosSA.id_tema}/${tipo_contenido}`
        );

        this.totalTemasSA = resp.data.length;
        let datarray = resp.data.filter(
          (el) => el.id == this.datosSA.id_clase
        );

        this.datosSA.correlativo_sa = datarray[0].orden_clase


        // // if (this.parametros.evento == "agregar") {
        //   this.datosSA.correlativo_sa = resp.data + 2;
        //   this.totalTemasSA = resp.data + 2;
        // // }

      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error al consultar datos de la programación del docente para la sesión de aprendizaje`,
          tiempo: null,
        });
      }
    },
  },
};
</script>